const columns = [
  {
    id: "finance_checkbox",
    label: (
      <input
        id="finance-checkbox-parent"
        type="checkbox"
        className="table-checkboxes finance-table-checkboxes-head"
      />
    ),
    minWidth: 20,
  },
  { id: "name", label: "Name", minWidth: 150 },
  { id: "bill_type", label: "Bill Type", minWidth: 50 },
  {
    id: "_id",
    label: "Transaction ID",
    minWidth: 150,
    align: "left",
  },
  {
    id: "status",
    label: "Status",
    minWidth: 80,
    align: "left",
  },
  {
    id: "amount",
    label: "Amount (NGN)",
    minWidth: 80,
    align: "left",
  },
  {
    id: "date",
    label: "Date",
    minWidth: 120,
    align: "left",
  },
];

function sortData(data) {
  if (!data) return [];
  const finalArray = data?.map((e) => {
    return {
      finance_checkbox: (
        <input
          data={e?._id}
          id="finance-checkbox-children"
          type="checkbox"
          className="table-checkboxes finance-table-checkboxes"
        />
      ),
      name: e?.name,
      bill_type: e?.bill_type,
      _id: e?._id,
      status: (
        <span
          className={
            e?.status === "pending"
              ? "high-severity-f"
              : e?.status === "cancelled"
              ? "high-severity-f"
              : "low-severity-f"
          }
        >
          {e?.status}
        </span>
      ),
      amount: e?.amount,
      date: new Intl.DateTimeFormat("en-us", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(new Date(e?.initiated_on)),
    };
  });

  return finalArray;
}

export { sortData, columns };
